// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_auth0_auth0-react_dist_auth0-react_esm_js-node_modules_datadog_browser-l-5cc61e"], () => (__webpack_require__("./src/app.tsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
